// extracted by mini-css-extract-plugin
export default {"tooltip":"Kn-z","sharingV2":"Ln-z","sharingIconsV2":"Mn-z","links":"Nn-z","link":"On-z","facebookV2":"Pn-z","twitterV2":"Qn-z","pinterestV2":"Rn-z"};